// Components==============
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import { HighlightExerciseContext } from '../HighlightExercise';
import useWrongAnimation from '../utils/useWrongAnimation';
import './Card.module.scss';
import Sentence from './Sentence/Sentence';
import Word from './Word/Word';
import Words from './Words/Words';
// =========================

export default function Card({ index }: { index: number }) {
    const {
        selected,
        answeredSentences,
        sentences,
        readSentenceSequence,
    } = useContext(HighlightExerciseContext);

    const { wrong, setWrong } = useWrongAnimation();

    if (selected.index !== index && selected.type !== 'sentences') return null;

    const isReading = readSentenceSequence === index;

    const sentenceStatus =
        answeredSentences.find((as) => as.id === sentences[index].id)?.status ||
        'initial';

    const variants = {
        initial: {
            backgroundColor: isReading ? '#cfe1fa' : '#fff',
        },
        whileHover: {
            backgroundColor: selected.type === 'sentences' ? '#cfe1fa' : '#fff',
        },
        wrong: {
            x: [0, -5, 5, -5, 0],
            backgroundColor: '#fff',
        },
    };

    return (
        <motion.div
            initial="initial"
            whileHover="whileHover"
            animate={wrong ? 'wrong' : 'initial'}
            variants={variants}
            transition={{ duration: selected.type === 'sentences' ? 0.4 : 0.1 }}
            styleName="wrapper"
        >
            {selected.type === 'sentences' ? (
                <Sentence
                    index={index}
                    status={sentenceStatus}
                    wrong={wrong}
                    setWrong={setWrong}
                />
            ) : selected.type === 'sentence' ? (
                <Words />
            ) : (
                // selected.type === 'word'
                <Word />
            )}
        </motion.div>
    );
}
